import React, { createContext, ReactNode, useContext, useState } from 'react';
import AppError from '../errors/AppError';

type DomainProps = {
  state: {
    tenantDomain: string;
  };
};

const TenantDomainContext = createContext<DomainProps>({
  state: {
    tenantDomain: '',
  },
});

const TenantDomainContextProvider = ({ children }: { children: ReactNode }) => {
  const [state] = useState({
    tenantDomain: 'aquario.com.br',
  });

  return (
    <TenantDomainContext.Provider
      value={{
        state,
      }}
    >
      {children}
    </TenantDomainContext.Provider>
  );
};

function useTenantDomain(): DomainProps {
  const context = useContext(TenantDomainContext);

  if (!context) {
    throw new AppError('useAuth deve ser usado dentro de um AuthProvider');
  }

  return context;
}

export { TenantDomainContextProvider, useTenantDomain };
